<template lang="pug">
	.project-settings(v-if="showed && project")
		.card
			.card-header
				i.fa.fa-edit
				span Project Settings
				.project-id Project id: {{project.id}}
			.card-body.collapse.show
				.form-horizontal
					.form-group.separator
						label.col-form-label Project title
							.controls
								input.form-control.title(size="16" type="text" v-model="title" @input="updateTitle")
					.form-group(v-if="_.size(publisher.options.projectMarkers) > 0")
						label.col-form-label Project markers
						.marker-list
							button.project-marker.btn(:class="{'btn-outline-dark': !_.includes(project.options.markers, marker), 'btn-primary': _.includes(project.options.markers, marker)}" type="button" @click="changeProjectMarker(marker)" v-for="(markerData, marker) in publisher.options.projectMarkers") {{marker}}
					.form-group.form-hide.separator(v-if="_.size(publisher.options.projectMarkers) > 0")
						label Show only in these markers menu
						label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
							input.switch-input.form-check-input(type="checkbox" :checked="project.options['showOnlyInMarkersMenu']" @change="saveOption('showOnlyInMarkersMenu', $event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
					.progress.add-progress(:style="{display: isUploading ? 'block' : 'none'}")
						.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (uploadProgress * 100) + '%'}")
					.form-actions
						button.btn.btn-danger(v-if="canDeleteProject() && project" type="button" @click="deleteProject()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Delete project'}")
							i.fa.fa-remove
							span Delete
						button.btn.btn-primary(type="button" v-on:click="uploadIcon()")
							i.fa.fa-upload
							span Upload icon
						button.btn.btn-dark(type="button" @click="hide()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen';

	import { Project } 			from '../../services/Project';
	import { Version } 			from '../../services/Version';
	import { Settings } 		from '../../services/Settings';

	export default {
		name: "ProjectSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Project Markers Changed",
				"Selected Project End Card Markers Changed"
			]
		},
		data() {

			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			return {
				title: '',
				isUploading: false,
				uploadProgress: 0
			}
		},
		methods: {
			collectData() {

				if (!Project.SelectedProject) return;

				this.project = Project.SelectedProject;
				this.title = this.getProjectTitle();
				this.publisher = Publisher.Publishers[this.project['publisher_id']];

			},
			updateTitle() {

				Server.sendWithTimeout({
					RenameProject: {
						projectId: this.project.id,
						title: this.title.trim()
					}
				}, null, 200);

			},
			uploadIcon() {

				this.uploadProgress = 0;

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "image/png, image/jpeg, image/gif";

				input.addEventListener('change', e => {

					this.uploadIconFile(e.target.files[0]);

					document.body.removeChild(input);

				});

				input.addEventListener('blur', e => {

					document.body.removeChild(input);

				});

				input.click();

			},
			uploadIconFile(file) {

				let formData = new FormData();

				formData.append("projectId", Project.SelectedProject.id);
				formData.append("file", file);

				let url = `${location.protocol}//${SetupSettings["domain"]}/project/updateIcon`;

				let xhr = new XMLHttpRequest();

				xhr.withCredentials = true;

				xhr.open("POST", url);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.uploadProgress = e.loaded / e.total;

					}

				};

				xhr.upload.onloadstart = e => {

					this.isUploading = true;

				};

				xhr.upload.onloadend = e => {

					this.isUploading = false;

				};

				xhr.send(formData);

			},
			getProjectTitle() {

				return this.project?.title || '';

			},
			changeProjectMarker(projectMarkerName) {

				if (_.includes(this.project.options.markers, projectMarkerName)) {

					Server.sendToServer({
						UnsetProjectMarker: {
							projectId: this.project.id,
							projectMarkerName: projectMarkerName
						}
					});

				} else {

					Server.sendToServer({
						SetProjectMarker: {
							projectId: this.project.id,
							projectMarkerName: projectMarkerName
						}
					});

				}

			},
			saveOption(optionName, newData) {

				this.project.options[optionName] = newData;

				Server.sendWithTimeout({
					UpdateProjectOptions: {
						projectId: this.project.id,
						[optionName]: this.project.options[optionName]
					}
				}, null, 300);

			},
			canDeleteProject() {

				if (User.currentUser.Tags['admin'] || User.currentUser.Tags['publisher-admin']) return true;

				return (this.publisher && this.publisher.options && this.publisher.options['canDeleteProjects']);

			},
			deleteProject() {

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

				Broadcast.call("Show ProjectActionsDelete", []);

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.project-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.project-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.1

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 500px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input.title
				width: 460px
				margin-top: 5px

			.btn-danger, .btn-primary
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.btn-warning
				white-space: nowrap
				margin-right: 20px

			.switch-slider
				background-color: #343b41
				border: 1px solid #23282c

			.progress.add-progress
				height: 5px
				margin-top: 10px
				margin-bottom: 10px

		.form-hide
			display: flex
			flex-direction: row

		.form-group
			display: flex
			flex-direction: column

		.marker-list
			display: flex
			flex-direction: row
			margin-bottom: 0px

			button.project-marker
				margin-right: 10px

		.multi-select-checkbox
			margin-bottom: 10px
			margin-right: 20px

			label
				margin-bottom: 0
				cursor: pointer

				.form-check-input
					top: -1px

				input
					cursor: pointer

		.form-actions
			margin-top: 20px

</style>

